import * as Configuration from '../../../app.constants.js';

export class CompanyContactsService {
  constructor($http, $translate, AsyncRequestFactory) {
    this.$http = $http;
    this.$translate = $translate;
    this.AsyncRequestFactory = AsyncRequestFactory
  }

  getCompanyContacts(companyId) {
    return this.$http.get(Configuration.constants.baseUrl +  'api/1.0/companies/' + companyId + '/parameters/company-contacts');
  }

  createCompanyContact(companyId, contact) {
    return this.$http.post(Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/parameters/company-contacts', contact);
  }

  editCompanyContact(companyId, contact) {
    return this.$http.put(Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/parameters/company-contacts/' + contact.id, contact);
  }

  deleteCompanyContact(companyId, contactId) {
    return this.$http.delete(Configuration.constants.baseUrl +  'api/1.0/companies/' + companyId + '/parameters/company-contacts/' + contactId);
  }

  createExport(companyId, contacts) {
    return this.AsyncRequestFactory.post(companyId, Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/parameters/company-contacts/export',  contacts)
  }

  static CompanyContactsFactory($http,$translate, AsyncRequestFactory) {
    return new CompanyContactsService($http, $translate,AsyncRequestFactory);
  }
}

CompanyContactsService.CompanyContactsFactory.$inject = ['$http', '$translate', 'AsyncRequestFactory']